import { DollarCircleOutlined, EnvironmentOutlined, EyeOutlined, FileTextOutlined, GlobalOutlined, MailOutlined, PhoneOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Col, Divider, Row, Space, Switch, Tag, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import TauxCommissionsIntermediaireDefinition from './TauxCommissionsIntermediaireDefinition';
import axiosInstance from '../../../variables/api/axiosInstance';
import { displayNumbers } from '../../../variables/numbersFunctions';


const { Title, Text } = Typography;

const colors = {
    primary: '#242166',
    secondary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    info: '#13c2c2',
    light: '#f0f2f5',
    gradient1: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
    gradient2: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    gradient3: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    gradient4: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
};

const ProfilingIntermediaire = ({ intermediaire, userExists, categories, setReload, validatedContrats, setShowModal, sumCommission, commissionValues, setCommissionValues, canEditRates = true }) => {

    const [manageTauxOpen, setManageTauxOpen] = useState(false);
    // Base de commission : false = prime nette seule (défaut), true = prime nette + accessoires.
    const [commAccessoires, setCommAccessoires] = useState(!!intermediaire?.commissionAvecAccessoires);
    const [savingComm, setSavingComm] = useState(false);
    useEffect(() => {
        setCommAccessoires(!!intermediaire?.commissionAvecAccessoires);
    }, [intermediaire]);

    const saveCommissionBase = (checked) => {
        if (!intermediaire?.codeId) return;
        setSavingComm(true);
        setCommAccessoires(checked);
        axiosInstance
            .put(`/api/intermediaire/${intermediaire.codeId}/commission-accessoires/${checked}`)
            .then(() => { toast.success("Base de commission mise à jour"); if (setReload) setReload((r) => !r); })
            .catch(() => { toast.error("Erreur lors de la mise à jour"); setCommAccessoires(!checked); })
            .finally(() => setSavingComm(false));
    };

    const initials = `${intermediaire?.personne?.prenom?.charAt(0) || ''}${intermediaire?.personne?.nom?.charAt(0) || ''}` || 'PI';
    const fullName = `${intermediaire?.personne?.prenom || ''} ${intermediaire?.personne?.nom || ''}`.trim()
        || intermediaire?.raisonSociale
        || 'Intermédiaire';

    const detailItems = [
        {
            key: 'responsable',
            label: 'Responsable',
            value: fullName,
            icon: <UserOutlined style={{ color: colors.primary }} />
        },
        {
            key: 'email',
            label: 'Email',
            value: intermediaire?.personne?.email || '-',
            icon: <MailOutlined style={{ color: colors.secondary }} />
        },
        {
            key: 'contact',
            label: 'Contacts',
            value: intermediaire?.personne?.contact?.length
                ? `(+228) ${intermediaire.personne.contact[0]}`
                : '-',
            icon: <PhoneOutlined style={{ color: colors.success }} />
        },
        {
            key: 'siege',
            label: 'Siège social',
            value: intermediaire?.personne?.adresse || '-',
            icon: <EnvironmentOutlined style={{ color: colors.warning }} />
        },
        {
            key: 'site',
            label: 'Site web',
            value: intermediaire?.personne?.siteWeb || '-',
            icon: <GlobalOutlined style={{ color: colors.info }} />
        },
        // {
        //     key: 'doubleAuth',
        //     label: 'Double authentification',
        //     value: intermediaire?.doubleAuthentification ? 'Activée' : 'Non activée',
        //     icon: <SafetyCertificateOutlined style={{ color: colors.primary }} />
        // },
    ].filter((item) => item.value);

    const tauxList = intermediaire?.tauxCommission?.length ? intermediaire.tauxCommission : [];

    const statsCards = [
        {
            key: 'contracts',
            label: 'Contrats',
            value: validatedContrats.length,
            gradient: colors.gradient2,
            icon: <FileTextOutlined style={{ color: 'white' }} />
        },
        {
            key: 'production',
            label: 'Production',
            value: `${displayNumbers(sumCommission || 0)} FCFA`,
            gradient: colors.gradient3,
            icon: <DollarCircleOutlined style={{ color: 'white' }} />
        },
    ];

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Space direction="vertical" align="center" style={{ width: '100%' }}>
                {intermediaire?.personne?.photo_url ? (
                    <div
                        style={{
                            display: 'inline-flex',
                            marginBottom: 8,
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            maxWidth: 200,
                            maxHeight: 200,
                            borderRadius: 12,
                            boxShadow: '0 4px 12px rgba(36, 33, 102, 0.15)'
                        }}
                    >
                        <img
                            src={intermediaire.personne.photo_url}
                            alt={fullName}
                            style={{
                                width: 'auto',
                                height: 'auto',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                ) : (
                    <Avatar
                        size={96}
                        style={{
                            backgroundColor: colors.primary,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        icon={<UserOutlined />}
                    >
                        {initials}
                    </Avatar>
                )}
                <div style={{ textAlign: 'center' }}>
                    <Title level={4} style={{ marginBottom: 4 }}>{fullName}</Title>
                    <Tag color="blue">{intermediaire?.profil?.nom || 'Intermédiaire'}</Tag>
                </div>
            </Space>

            <Row gutter={[16, 16]} style={{ width: '100%' }}>
                {statsCards.map((card) => (
                    <Col span={12} key={card.key}>
                        <div
                            style={{
                                background: card.gradient,
                                borderRadius: 12,
                                padding: 16,
                                color: 'white',
                                minHeight: 110
                            }}
                        >
                            <Space size="large" align="start">
                                <Avatar
                                    shape="square"
                                    size={48}
                                    style={{ background: 'rgba(255,255,255,0.2)' }}
                                >
                                    {card.icon}
                                </Avatar>
                                <div>
                                    <Text style={{ color: 'rgba(255,255,255,0.8)' }}>{card.label}</Text>
                                    <Title level={3} style={{ color: 'white', margin: 0 }}>{card.value}</Title>
                                </div>
                            </Space>
                        </div>
                    </Col>
                ))}
            </Row>

            <Divider style={{ margin: '8px 0' }} />

            <div style={{ width: '100%' }}>
                <Title level={5} style={{ marginBottom: 12 }}>Détails</Title>
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    {detailItems.map((item) => (
                        <Space key={item.key} align="start">
                            <Avatar
                                shape="square"
                                size={40}
                                style={{ background: '#f6f7fb', color: colors.primary }}
                            >
                                {item.icon}
                            </Avatar>
                            <div>
                                <Text type="secondary" style={{ textTransform: 'uppercase', fontSize: 12 }}>
                                    {item.label}
                                </Text>
                                <div>
                                    <Text strong>{item.value}</Text>
                                </div>
                            </div>
                        </Space>
                    ))}
                </Space>
            </div>

            {tauxList.length ? (
                <>
                    <Divider style={{ margin: '8px 0' }} />
                    <div style={{ width: '100%' }}>
                        <Text type="secondary" style={{ textTransform: 'uppercase', fontSize: 12 }}>
                            Derniers taux définis
                        </Text>
                        <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
                            {tauxList.map((tc) => (
                                <div
                                    key={tc?.categorie?.codeCategorie || tc?.categorie?.nom}
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <Text>
                                        {tc?.categorie?.nom || tc?.categorie?.codeCategorie}
                                    </Text>
                                    <Text strong>{tc?.taux || 0}%</Text>
                                </div>
                            ))}
                        </Space>
                    </div>
                </>
            ) : null}

            {/* Base de calcul de la commission de cet intermédiaire. */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, margin: '4px 0 12px' }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Base de commission : <b>{commAccessoires ? 'Prime nette + accessoires' : 'Prime nette seule'}</b>
                </Text>
                <Switch checked={commAccessoires} loading={savingComm} onChange={saveCommissionBase} />
            </div>

            <Button
                type="primary"
                ghost
                block
                icon={canEditRates ? <PlusOutlined /> : <EyeOutlined />}
                onClick={() => setManageTauxOpen(true)}
                style={{ marginBottom: 12 }}
            >
                {canEditRates ? 'Gérer les taux de commission' : 'Voir les taux de commission'}
            </Button>
            <Button
                icon={<UserOutlined />}
                onClick={() => setShowModal(true)}
                disabled={userExists}
                block
            >
                {userExists ? 'Compte associé' : 'Associer un compte'}
            </Button>
            <TauxCommissionsIntermediaireDefinition categories={categories} manageTauxOpen={manageTauxOpen} setManageTauxOpen={setManageTauxOpen} intermediaire={intermediaire} setReload={setReload} commissionValues={commissionValues} setCommissionValues={setCommissionValues} canEditRates={canEditRates} />
        </Space>
    )
}

export default ProfilingIntermediaire
